export const invitationTypes = {
  SUPPLIER_INVITE_CUSTOMER: 'SUPPLIER_INVITE_CUSTOMER',
  SUPPLIER_INVITE_USER: 'SUPPLIER_INVITE_USER',
  CONTRACTOR_INVITE_SUPPLIER: 'CONTRACTOR_INVITE_SUPPLIER',
  GETPAID_INVITE: 'GETPAID_INVITE',
  CREDIT_INVITE: 'CREDIT_INVITE',
}
